import { useScrollReveal } from '@/hooks/useScrollReveal';
import { useCountUp } from '@/hooks/useCountUp';
import { stats } from '@/mocks/projects';

export default function StatsBar() {
  const { ref, isVisible } = useScrollReveal(0.3);

  return (
    <section ref={ref} className="relative py-16 md:py-20 border-y border-stone-200/60 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-stone-100/50 via-cream-50 to-stone-100/50"></div>
      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-center gap-20 md:gap-32">
          {stats.map((stat) => (
            <StatItem key={stat.label} stat={stat} isVisible={isVisible} />
          ))}
        </div>
      </div>
    </section>
  );
}

function StatItem({ stat, isVisible }: { stat: typeof stats[0]; isVisible: boolean }) {
  const count = useCountUp(stat.value, 2200, isVisible);

  return (
    <div className="text-center group">
      <div className="font-serif text-4xl md:text-5xl lg:text-7xl text-charcoal-900 mb-2 tracking-tight transition-all duration-500 group-hover:scale-105">
        {count}{stat.suffix}
      </div>
      <p className="text-xs md:text-sm text-stone-500 tracking-wide uppercase whitespace-nowrap transition-colors duration-300 group-hover:text-terracotta-600">
        {stat.label}
      </p>
    </div>
  );
}